"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADLIB = void 0;
const Note_1 = require("../Note");
const NoteType_1 = require("../lib/NoteType");
/**
 * Hidden note that will increase combo if discovered and does not give a BAD
 * when missed. Represented as `F`.
 */
class ADLIB extends Note_1.Note {
    constructor() {
        super(NoteType_1.NoteType.ADLIB);
    }
}
exports.ADLIB = ADLIB;
